import { FormLogEvent } from '../gravity-form/types';

export const classNameBySize: Record<string, string> = {
  medium: 'w-1/2',
  large: 'w-full',
};

export const formActionByInputName: Record<string, FormLogEvent> = {
  user_name: 'Name field interaction',
  user_email: 'Email field interaction',
  _next_user_phone_input: 'Phone field interaction',
  pr_fs_understand_price: 'Check interaction',
  user_cookie_consent: 'Check privacy policy',
  pr_fs_goal: 'Dropdown interaction',
};
